import deviceAPI from '@/api/device';
import types from './mutations-types';
import websocketApi from '@/api/websocketApi';

export default {
  namespaced: true,
  state: {
    /**
     * 当前选中的设备序号
     */
    selectedDeviceIndex: parseInt(window.sessionStorage.getItem('selectedDeviceIndex'), 10),
    deviceList: [],
    searchVal: '',
    /**
     * 当前选中的设备信息
     */
    curDeviceData: {},
    /**
     * 当前选中设备的文件列表
     */
    deviceFileList: [],
    /**
     * 当前设备的配置信息
     */
    curDeviceConfig: {},
    /**
     *设备文件列表刷新情况
     */
    fileRefreshResult: {},
    /**
     * 所有设备文件的列表（包括在线及非在线设备）
     */
    fileListOverall: [],
    otaSubscription: new Map(),
    /**
     * 当前选中的设备在线状态
     */
    curDeviceOnline:true,
    uploadProgressSubscription:new Map(),
    autoFileUploadStatusSubscription: new Map(),
    otaErrorMsgSubscription: new Map(),
    // 当前正在上传的设备列表
    uploadingList: [],
    // 当前状态：是否在上传？
    isUploading: false,
    // ota错误消息
    otaErrorMsg: '',
    otaStatus: false,
    isGetOTAProgress: false,
  },
  getters: {
    // filterDeviceList: (state) => {
    //   const { deviceList, searchValue } = state;
    //   return deviceList.filter(item => item.name.includes(searchValue));
    // },
    // 第一次加载时无缓存，默认第一个设备
    getOtaStatus: state => state.otaStatus,
    getotaErrorMsg: state => state.otaErrorMsg,
    getDeviceIndex: state => (state.selectedDeviceIndex % 1 === 0 ? state.selectedDeviceIndex : 0),
    deviceFileList: state => state.deviceFileList,
    getuploadingList: state => state.uploadingList,
    getisUploading: state => state.isUploading,
    getSearchVal: state => state.searchVal,
    /**
     * 根据名字获取设备对象
     * @param state
     * @param name
     * @return {function(*=): T[]}
     */
    getByName: state => name => state.deviceList.filter(item => item.name.includes(name)),
    getRefreshResult: state => state.fileRefreshResult,
    getDeviceConfig: state => state.curDeviceConfig,
    getFileListOverall: state => state.fileListOverall,
    getFileListByFilter: state => obj => state.fileListOverall.filter(item => item.name.includes(obj.name) && item.device.includes(obj.device)),
  },
  mutations: {
    [types.SET_INDEX](state, index) {
      state.selectedDeviceIndex = index;
      window.sessionStorage.setItem('selectedDeviceIndex', index);
    },
    /**
     * 设置OTA状态
     * @param state
     * @param status
     */
    [types.SET_OTA_STATUS](state, status) {
      state.otaStatus = status;
    },
    // 把取到的数据存到state中的List
    [types.SET_LIST](state, payload) {
      state.deviceList = payload.deviceList;

      /**
       *@Description: 为测试文件管理，加上设备在线信息，后续应考虑接口中增加此信息
       *@Param: mod
       *@Author: SUN Hao
       *@date: 2019/3/6
       */
      // for (let deviceNum = 0; deviceNum < payload.deviceList.length; deviceNum += 1) {
      //   state.deviceList[deviceNum].online = 1;
      // }

      console.debug('设备列表被更新, value=', state.deviceList);
    },
    [types.SET_CURRENT_DETAIL](state, obj) {
      state.curDeviceData = obj;
      // 搜索无匹配时不显示设备信息
      if (typeof (obj.id) === 'undefined') {
        state.curDeviceData = {};
      } else {
        const data = state.deviceList.filter(item => item.id === obj.id);
        // console.assert(data.length === 1, `在设备列表中没有发现id=${obj.id}的设备`);
        // console.debug('当前设备详情的设备属性=', data[0]);
        state.curDeviceData.networkStatus = data[0].networkStatus;
      }


      // state.curDeviceData
    },
    // input搜索的值
    [types.SET_SEARCH_VAL](state, payload) {
      if (payload !== null) {
        payload = payload.replace(/^\s+|\s+$/g, '');
      }
      state.searchVal = payload;
    },
    // 设置设备文件列表,考虑文件列表为空的情况
    [types.SET_CURRENT_FILE_LIST](state, payload) {
      state.deviceFileList = payload.map(item => ({
        id: item.id || '',
        name: item.name || '',
        createTime: item.createTime || '',
        length: item.length || '',
        status: item.status,
      }));
    },
    [types.SET_CURRENT_CONFIG](state, payload) {
      state.curDeviceConfig = payload;
    },

    // 依照文件列表刷新的结果设置参数值，以用于对用户的进一步提示
    [types.SET_REFRESH_RESULT](state, payload) {
      state.fileRefreshResult = {
        name: payload.name,
        success: payload.success,
        errorCode: payload.errorCode,
        errorMsg: payload.errorMsg,
      };
    },
    [types.SET_FILE_LIST_OVERALL](state, payload) {
      state.fileListOverall = payload;
    },
    [types.SET_UPLOADING_LIST](state, payload) {
      state.uploadingList = payload;
    },
    [types.SET_IS_UPLOADING](state, payload) {
      state.isUploading = payload;
    },
    [types.SET_OTA_ERRORMSG](state, payload) {
      state.otaErrorMsg = payload;
    },
    // 设置选中设备状态
    [types.SET_CURRENT_ONLINE](state,payload){
      state.curDeviceOnline = payload
    },
    setIsGetOTAProgrss(state, payload) {
      state.isGetOTAProgress = payload;
    },
  },
  actions: {
    // 获取列表数据
    async getDeviceList({ commit }) {
      await deviceAPI.listDevice()
        .then((res) => {
          if (res instanceof Array) {
            commit(types.SET_LIST, { deviceList: res });
          } else {
            commit(types.SET_LIST, { deviceList: [] });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 获取指定device的详细数据
    async getDeviceDetail({ commit }, payload) {
      await deviceAPI.getDeviceDetail(payload.id)
        .then((res) => {
          console.log('curDevData', res);
          commit(types.SET_CURRENT_DETAIL, res);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    // 重命名
    renameDevice({ commit }, payload) {
      const { id, name } = payload;
      return deviceAPI.renameDevice(id, name)
        .then(() => {
        })
        .catch((err) => {
          console.error(err);
        });
    },
    /**
     * 检查当前设备的文件列表是否有更新,通知设备将最新列表信息同步至服务器
     * @param state
     * @param dispatch
     * @param payload
     * @return {Promise<void>}
     */
    async checkFileListUpdate({ state, commit }, payload) {
      const { id, name } = payload;
      await deviceAPI.checkFileListUpdate(id)
        .then((res) => {
          commit('setRefreshResult', { name, success: true });
          Promise.resolve(commit);
        })
        .catch((err) => {
          commit('setRefreshResult', { name, success: false, errorCode: err[0], errorMsg: err[1] });
        });
    },
    /**
     * 刷新当前设备的文件列表
     * @param state
     * @param dispatch
     * @param payload
     * @return {Promise<void>}
     */
    async refreshCurDeviceFileList({ state, dispatch }, payload) {
      dispatch('getDeviceFileList', { id: state.curDeviceData.id });
    },
    /**
     * 获取当前设备文件列表
     * @returns {Promise<void>}
     */
    async getDeviceFileList({ commit }, payload) {
      // const {} = state;
      const { id } = payload;
      await deviceAPI.getDeviceFileList(id)
        .then((res) => {
          if (res instanceof Array) {
            commit(types.SET_CURRENT_FILE_LIST, res);
          } else {
            commit(types.SET_CURRENT_FILE_LIST, []);
          }
        })
        .catch(() => {
          // commit('setDeviceFileList', []);
        });
    },
    async getDeviceConfig({ state, commit }, payload) {
      const { id } = payload;
      await deviceAPI.getConfig(id)
        .then((res) => {
          commit(types.SET_CURRENT_CONFIG, res);
        });
    },
    /**
     * 获取当前文件上传状态，并调用相应函数进行渲染
     * @param state
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async getFileUploadStatus({ state, dispatch, commit }, payload) {
      const { id } = payload;
      dispatch('autoFileUploadStatusUnsubscription', { deviceId: id });
      dispatch('autoFileUploadStatusSubscription', { deviceId: id });
      await deviceAPI.getFileUploadStatus(id)
        .then((res) => {
          const uploadStatusArr = res.uploadStatusVOS;
          console.log('正在上传的文件列表：', uploadStatusArr);
          uploadStatusArr.forEach((element) => {
            const fileId = element.fileId;
            console.log('fileId1=', fileId);
            dispatch('uploadProgressUnsubscription', fileId);
            dispatch('setUploadStatus', { fileId });
          });
        });
    },
    /**
     * 根据文件id来实时跟新进度条，和文件上传状态
     * @param state
     * @param dispatch
     * @param commit
     * @param payload
     */
    setUploadStatus({ state, dispatch, commit }, payload) {
      const { fileId } = payload;
      console.log('fileId2=', fileId);
      const arr = state.uploadingList;
      arr.push(fileId);
      const isUploading = true;
      commit(types.SET_UPLOADING_LIST, arr);
      commit(types.SET_IS_UPLOADING, isUploading);
      dispatch('uploadProgressSubscription', { fileId });
    },
    /**
     * 对文件自动上传的订阅
     * @param state
     * @param rootState
     * @param commit
     * @param payload
     * @returns {Promise<void>}
     */
    async autoFileUploadStatusSubscription({ state, rootState, dispatch }, payload) {
      const { deviceId } = payload;
      if (rootState.App.socketState.isConnected) {
        console.log('wkb 已订阅');
        const autoFileUploadUrl = websocketApi.autoFileUploadStatus(deviceId);
        const subList = [];
        const sub = rootState.App.SOCKET.subscribe(autoFileUploadUrl, (msg) => {
          // console.log("当前进度"+msg.body)
          const body = JSON.parse(msg.body);
          console.log('wkbbady= ', body);
          const List = body.data.uploadFileList;
          List.forEach((element) => {
            const fileId = element.fileIdByServer;
            dispatch('setUploadStatus', { fileId });
          });
        });
        subList.push(sub);
        state.autoFileUploadStatusSubscription.set(deviceId, subList);
      }
    },
    /**
     * 取消对文件自动上传的订阅
     * @param state
     * @param rootState
     * @param payload
     * @returns {Promise<void>}
     */
    async autoFileUploadStatusUnsubscription({ state, rootState }, payload) {
      const { deviceId } = payload;
      const subList = state.autoFileUploadStatusSubscription.get(deviceId);
      // 想要达成的效果是，点击设备订阅前先取消上次订阅；但是刷新后是找不到上次订阅的东西的，所以进行了如下判断；
      if (subList !== undefined) {
        if (rootState.App.socketState.isConnected) {
          subList.map((item) => {
            item.unsubscribe();
          });
        }
      }
    },
    /**
     * 订阅ota错误信息
     * @param state
     * @param rootState
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async otaErrorMsgSubscription({ state, rootState, commit, dispatch }, payload) {
      const { deviceId, canIndex } = payload;
      if (rootState.App.socketState.isConnected) {
        console.log('wkb 已订阅');
        const otaErrorMsgUrl = websocketApi.otaErrorMsg(deviceId, canIndex);
        const subList = [];
        const sub = rootState.App.SOCKET.subscribe(otaErrorMsgUrl, (msg) => {
          const body = JSON.parse(msg.body);
          const otaErrorMsg = body.data.message;
          commit(types.SET_OTA_ERRORMSG, otaErrorMsg);
          dispatch('otaErrorMsgUnsubscription', deviceId);
          // 同时订阅多个CAN通道的话，发过来错误消息显示哪条。
        });
        subList.push(sub);
        state.otaErrorMsgSubscription.set(deviceId, subList);
      }
    },
    /**
     * 取消订阅ota错误消息
     * @param state
     * @param rootState
     * @param payload
     * @returns {Promise<void>}
     */
    async otaErrorMsgUnsubscription({ state, rootState }, payload) {
      const deviceId = payload;
      const subList = state.otaErrorMsgSubscription.get(deviceId);
      if (rootState.App.socketState.isConnected) {
        subList.map((item) => {
          item.unsubscribe();
        });
      }
    },
    /**
     * 删除某个文件，参数ID=文件ID
     * @param state
     * @param commit
     * @param payload
     * @return {Promise<T>}
     */
    async deleteFile({ state, commit }, payload) {
      const { id } = payload;
      //----------------------------------------------
      let idList=[]
      idList.push(id)
      //----------------------------------------------
      // const resultData = await deviceAPI.deleteFile(id)
      const resultData = await deviceAPI.deleteFile(idList)
        .then(() => {
          const list = state.deviceFileList;
          const targetIndex = list.findIndex(item => item.id === id);

          if (targetIndex !== -1) {
            list.splice(targetIndex, 1);
            commit(types.SET_CURRENT_FILE_LIST, list);
          }
          return Promise.resolve();
        })
        .catch(err => Promise.reject(err));
      return resultData;
    },
    /**
     * 用于获取当下所有文件的列表
     */
    async collectFiles({ state, commit, dispatch }) {
      dispatch('getDeviceList')
        .then(() => {
          const deviceList = state.deviceList;
          const length = deviceList.length;
          const allFileList = [];
          for (let deviceNum = 0; deviceNum < length; deviceNum += 1) {
            dispatch('getDeviceFileList', { id: deviceList[deviceNum].id })
              .then(() => {
                const fileList = state.deviceFileList;
                const curFileNum = allFileList.length;
                for (let index = 0; index < fileList.length; index += 1) {
                  allFileList[curFileNum + index] = fileList[index];
                  allFileList[curFileNum + index].device = deviceList[deviceNum].name;
                  allFileList[curFileNum + index].online = deviceList[deviceNum].online;
                  allFileList[curFileNum + index].deviceId = deviceList[deviceNum].id;
                  allFileList[curFileNum + index].online = deviceList[deviceNum].online;
                  allFileList[curFileNum + index].networkStatus = deviceList[deviceNum].networkStatus;
                }
              });
          }
          commit('setFileListOverall', allFileList);
        });
    },
    /**
     * 获取OTA状态
     * @param state
     * @param commit
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async getOTAStatus({ state, commit, dispatch }, payload) {
      const { deviceId } = payload;
      await deviceAPI.getOTAStatusHTTP(deviceId)
        .then((res) => {
          console.log('OTA状态', res);
          if (res && !state.isGetOTAProgress) {
            dispatch('getOTAProgressData', { deviceId });
            commit(types.SET_OTA_STATUS, res);
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    /**
     * 获取OTA进度
     * @param state
     * @param commit
     * @param dispatch
     * @param payload
     * @returns {Promise<void>}
     */
    async getOTAProgressData({ state, commit, dispatch }, payload) {
      commit('setIsGetOTAProgrss', true);
      const { deviceId } = payload;
      await deviceAPI.getOTAProgressHTTP(deviceId)
        .then((msg) => {
          console.log('aa当前进度：', msg);
          // eslint-disable-next-line prefer-destructuring
          const progress = msg.progress;
          // eslint-disable-next-line prefer-destructuring
          const errorMsg = msg.errorMsg;
          if (Number(progress) < 0) {
            commit(types.SET_OTA_ERRORMSG, errorMsg);
          } else {
            if (Number(progress) > 0) {
              commit('setOTAProgress', [], { root: true });
              commit('setOTAProgress', progress, { root: true });
              commit('setOTASuccess', [], { root: true });
              commit('setOTASuccess', true, { root: true });
              commit('setOTAError', errorMsg, { root: true });
            }
            if (Number(progress) < 100 && state.otaStatus) {
              // 以1s为周期调用获取进度的接口
              setTimeout(() => dispatch('getOTAProgressData', { deviceId }), 1500);
            } else {
              commit('setIsGetOTAProgrss', false);
              if (Number(progress) === 100) {
                console.log('进度条到达100%');
                commit(types.SET_OTA_STATUS, false);
              }
            }
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    /**
     * 进行OTA刷写的订阅
     */
    async otaSubscription({ state, rootState, commit }, payload) {
      commit('setOTAProgress', '0', { root: true });
      const { deviceId, canIndex } = payload;
      let subList = state.otaSubscription.get(deviceId) === undefined ?[]:state.otaSubscription.get(deviceId)
      if (rootState.App.socketState.isConnected) {
        //先取消订阅
        // subList.map((item)=>{
        //   item.unsubscribe()
        // })
        //进度条添加地方，与websocket建立连接，订阅
        subList=[]
        const subUrl = websocketApi.brushFinishedAck(deviceId, canIndex);
        const progressUrl=websocketApi.otaProgress(deviceId)
        //调用接口，把ota刷写的结果返回给sub
        let sub = rootState.App.SOCKET.subscribe(subUrl, (msg) => {
          console.log('OTA完成，收到反馈', msg.body);
          const body = JSON.parse(msg.body);
          commit('setOTAResult', [], { root: true });
          const otaResultArr = [];
          otaResultArr.push(body.deviceUid);
          otaResultArr.push(body.canIndex);
          otaResultArr.push(body.ok);
          console.log(otaResultArr);
          //与websocket建立连接
          commit('setOTAResult', otaResultArr, { root: true });
        });
        subList.push(sub)
        sub=rootState.App.SOCKET.subscribe(progressUrl,(msg)=>{
          console.log("当前进度",msg.body)
          const body=JSON.parse(msg.body)
          commit('setOTAProgress',[],{root:true})
          commit('setOTAProgress',body.data[body.data.length-1].progress,{root:true})
          commit('setOTASuccess',[],{root:true})
          commit('setOTASuccess',body.success,{root:true})
          commit('setOTAError',body.data[body.data.length-1].errorMsg,{root:true})
        })
        subList.push(sub)

        state.otaSubscription.set(deviceId,subList)
        // state.otaSubscription.push(sub);
      }
    },
    /**
     * 取消OTA刷写的订阅
     */
    async otaUnsubscription({ state, rootState, commit }, payload){
      // commit('setOTAProgress','0',{root:true})
      const deviceId = payload;
      // let subList = state.otaSubscription.get(deviceId) === undefined ?[]:state.otaSubscription.get(deviceId)
      let subList = state.otaSubscription.get(deviceId)
      console.log(deviceId,'|',subList)
      if (rootState.App.socketState.isConnected){
        subList.map((item)=>{
          item.unsubscribe()
        })
      }
    },
    /**
     * 进行文件上传进度的订阅
     */
    async uploadProgressSubscription({ state, rootState, commit }, payload) {
      const { fileId } = payload;
      let subList = state.uploadProgressSubscription.get(fileId) === undefined ?[]:state.uploadProgressSubscription.get(fileId)
      if (rootState.App.socketState.isConnected) {
        //先取消订阅
        // subList.map((item)=>{
        //   item.unsubscribe()
        // })
        //进度条添加地方，与websocket建立连接，订阅
        subList=[]
        const progressUrl=websocketApi.fileUploadProgress(fileId)
        let sub=rootState.App.SOCKET.subscribe(progressUrl,(msg)=>{
          // console.log("当前进度"+msg.body)
          const body=JSON.parse(msg.body)
          console.log(body)
          let progress = new Map(rootState.App.fileUploadProgress)
          progress.set(fileId,body.per)
          commit('setFileUploadProgress',progress,{root:true})
          // commit('setFileUploadProgress',[],{root:true})
          // commit('setFileUploadProgress',body.data[body.data.length-1].per,{root:true})
        })
        subList.push(sub)
        state.uploadProgressSubscription.set(fileId,subList)
      }
    },
    /**
     * 取消文件上传进度的订阅
     */
    async uploadProgressUnsubscription({ state, rootState, commit }, payload){
      let progress = new Map(rootState.App.fileUploadProgress)
      const fileId = payload;
      progress.delete(fileId)
      commit('setFileUploadProgress',progress,{root:true})
      let subList = state.uploadProgressSubscription.get(fileId)
      console.log(fileId,'|',subList)
      if (rootState.App.socketState.isConnected){
        subList.map((item)=>{
          item.unsubscribe()
        })
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/device/index.js